export const filterOptions = (selectOptions, searchValue) => {
  if (!searchValue.trim()) {
    return selectOptions;
  }
  return selectOptions.filter(option => option.text.toLowerCase().includes(searchValue.trimStart().toLowerCase()));
};